import React from 'react';
import './Footer.css';

export default function Footer(){
    const year = new Date().getFullYear();
    return (
        <h3>©{year} Harshil Jani - Part of Web Development for Fun Initiative</h3>
    )
}